import '@inovua/reactdatagrid-enterprise/theme/default-dark.css';
import '@inovua/reactdatagrid-enterprise/index.css';
import ReactDataGrid from '@inovua/reactdatagrid-enterprise';
import { IPage, IReloadFunctions, IRole } from '../../Types';
import { useState } from 'react';
import { scrollProps } from '../../../../../utils/ScrollProps';
import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@mui/material';
import AreYouSureModal from '../../../../../utils/AreYouSureModal';
import AddRolePageModal from '../Modals/AddRolePageModal';
import { deletePageRoleAllocation } from '../../API/API';
import useAuth from '../../../../../hooks/useAuth';
import { handleApiError } from '../../../../../utils/HandleApiError';
import { notifyError } from '../../../../../utils/Notification';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import useLocales from '../../../../../hooks/useLocales';

interface IPageTable {
  rolePages: IPage[];
  selRole: IRole | null;
  loadRoleData: (role: IRole) => void;
  reloadFunctions: IReloadFunctions;
}

export default function PagesTable(props: IPageTable) {
  const { t } = useLocales();
  const { logout } = useAuth();
  const [contextRow, setContextRow] = useState<IPage | null>(null);
  const [addUserPageModalState, setAddUserPageModalState] = useState(false);
  const [deleteModalState, setDeleteModalState] = useState(false);
  const isLoading = useSelector((state: RootState) => state.loadingSlice.isLoading);

  const renderRowContextMenu = (menuProps: any, info: any) => {
    if (info.cellProps.data.name !== 'Exists') {
      menuProps.autoDismiss = true;
      menuProps.items = [
        {
          label: t('delete'),
          onClick: () => {
            setContextRow(info.cellProps.data);
            setDeleteModalState(true);
          },
        },
        {
          label: t('copy'),
          onClick: () => {
            navigator.clipboard.writeText(info.cellProps.value); //copy cell value to clipboard
          },
        },
      ];
    }
  };

  async function deletePageEntry() {
    try {
      if (props.selRole && contextRow) {
        props.reloadFunctions.setLoading(true);
        await deletePageRoleAllocation(contextRow.Id, props.selRole.Id);
        props.loadRoleData(props.selRole);
      }
    } catch (error) {
      handleApiError(error, logout);
      notifyError(t('error_deleting_permission_page'), 'error_deleting_role_page');
    }
  }

  return (
    <>
      <ReactDataGrid
        licenseKey={process.env.REACT_APP_DATA_GRID_KEY}
        scrollProps={scrollProps}
        idProperty="Id"
        columns={[
          {
            name: 'Id',
            header: 'Id',
            headerAlign: 'center',
            visible: false,
          },
          {
            name: 'name',
            header: 'Name',
            headerAlign: 'center',
            defaultFlex: 1,
          },
          {
            name: 'pageUuid',
            header: 'UUID',
            headerAlign: 'center',
            defaultFlex: 1,
          },
        ]}
        defaultFilterValue={[
          { name: 'name', operator: 'contains', type: 'string', value: '' },
          { name: 'pageUuid', operator: 'contains', type: 'string', value: '' },
        ]}
        dataSource={props.selRole ? props.rolePages : []}
        style={{ minHeight: '100%' }}
        enableColumnAutosize
        renderRowContextMenu={renderRowContextMenu}
        columnUserSelect
      />
      {!isLoading && props.selRole && (
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', bottom: '30px', right: '30px' }}>
            <Fab onClick={() => setAddUserPageModalState(true)} color="primary" aria-label="add">
              <AddIcon />
            </Fab>
          </div>
        </div>
      )}
      <AddRolePageModal modalState={addUserPageModalState} setModalState={setAddUserPageModalState} selRole={props.selRole} assignedRolePages={props.rolePages} loadRoleData={props.loadRoleData} />
      <AreYouSureModal modalState={deleteModalState} setModalState={setDeleteModalState} callIfYes={deletePageEntry} />
    </>
  );
}
